import { LoadingButton } from "@mui/lab";
import { Backdrop, Box, Button, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import { deletePriceTypeDropdown } from "../../../graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../../../components/snackBar/snakbar";
import theme from "../../../styles/Themecolors";
import { createPriceType } from "../../../graphql";
import { useCreatePriceTypeMutation } from "../../../redux/apis/pricetype.api";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
};
function DeletePriceType({
  open,
  setOpen,
  priceTypeID,
  listPriceDetails,
  setPriceTypeID,
  deleteObj,
}) {
  const [
    createPriceType,
    {
      isLoading: iscreatePriceType,
      isError: iscreatePriceTypeError,
      isSuccess: iscreatePriceTypeSuccess,
      error: createPriceTypeError,
    },
  ] = useCreatePriceTypeMutation();

  const [loading, setLoading] = useState(false);
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  const deleteItem = async () => {
    setLoading(true);
    try {
      // const deleteRelationData = await API.graphql(
      //   graphqlOperation(deletePriceTypeDropdown, {
      //     PriceTypeID: priceTypeID,

      //   })
      // );
      Math.floor(new Date().getTime() / 1000);
      const exp = Math.floor(new Date().getTime() / 1000);
      let obj = {
        pricetype: deleteObj.priceType,
        is_active: 1,
        id: deleteObj.Id,
        expiredtimestamp: exp,
      };
      // const resItem = await API.graphql(
      //   graphqlOperation(createPriceType, {
      //     pricetype: JSON.stringify([obj]),
      //   })
      // );

      const resItem = await createPriceType({
        pricetype: JSON.stringify([obj]),
      });
      if (resItem.data?.statuscode === "Success") {
        setOpen(false);
        setLoading(false);
        setPriceTypeID("");
        showSuccessSnackbar("Price Type deleted");
      } else {
        showWarningSnackbar(resItem?.error?.message);
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
      const rawMessage = error.errors[0].message.split("RDSHttp:")[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split("ERROR: ")[1].split(";")[0];
      showWarningSnackbar(errorMessage);
    }
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Box sx={style}>
        <Box
          sx={{
            borderRadius: "4px",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <Typography
            sx={{
              color: theme?.palette?.TmId.id.toString().includes("9")
                ? "#FFF1E6"
                : "rgb(60 60 60)",
              fontWeight: "bold",
            }}
          >
            Do you want to delete this item?
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            disabled={loading}
            onClick={handleClose}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          <LoadingButton
            color="error"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={() => deleteItem()}
          >
            Yes
          </LoadingButton>
        </Box>
      </Box>
      {/* </Fade> */}
    </Modal>
  );
}

export default DeletePriceType;
